<script>
import Icon from "./Icon";

export default {
  name: "Btn",
  components: {
    Icon
  },
  props: {
    id: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: ""
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    disabledIcon: {
      type: String,
      default: "polmed"
    },
    title: {
      type: String,
      default: ""
    },
    disabledTitle: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "b-button"
    }
  },

  render(h) {
    const children = [];
    const text =
      this.$slots.default ||
      (this.$attrs.disabled ? this.disabledTitle : this.title) ||
      "";
    const data = { props: this.$attrs, on: this.$listeners };

    let icon = null;

    if (this.tooltip) {
      data.directives = [
        { name: "b-tooltip", modifiers: ["hover"], value: this.tooltip }
      ];
    }

    children.push(text);

    if (this.icon) {
      icon = h("Icon", {
        props: { name: this.$attrs.disabled ? this.disabledIcon : this.icon }
      });

      if (this.iconRight) {
        children.push(icon);
      } else {
        children.unshift(icon);
      }
    }

    data.class = {
      "btn--icon-left": this.icon && !this.iconRight,
      "btn--icon-right": this.iconRight,
      "btn--text": text,
      "btn--no-text": !text
    };

    if (this.type !== "b-button") {
      data.class.btn = true;
      data.class[`btn-${this.$attrs.variant}`] = true;
    }

    return h(this.type, data, children);
  }
};
</script>

<style>
.btn .polmed__spinner {
  top: -2px;
  width: 20px !important;
  height: 20px !important;
}
.btn--icon-left .polmed__spinner {
  margin-right: 7px;
}
.btn--icon-right .polmed__spinner {
  margin-left: 7px;
}
</style>
